import React, { useState, useEffect } from 'react';

interface NumberTickerProps {
  to: number;
  duration?: number;
  prefix?: string;
  suffix?: string;
  format?: (n: number) => string;
  style?: React.CSSProperties;
  className?: string;
}

export const NumberTicker: React.FC<NumberTickerProps> = ({
  to,
  duration = 1400,
  prefix = '',
  suffix = '',
  format,
  style,
  className,
}) => {
  const [v, setV] = useState(0);

  useEffect(() => {
    let raf: number;
    const t0 = performance.now();

    function step(now: number) {
      const p = Math.min(1, (now - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      setV(to * eased);
      if (p < 1) {
        raf = requestAnimationFrame(step);
      }
    }

    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [to, duration]);

  const shown = format ? format(v) : Math.round(v).toLocaleString();

  return (
    <span style={{ fontVariantNumeric: 'tabular-nums', ...style }} className={className}>
      {prefix}
      {shown}
      {suffix}
    </span>
  );
};

export default NumberTicker;
